<template>
    <section class="mx-auto max-w-7xl px-6 lg:px-8 pt-8">
        <div class="w-full flex-col justify-start items-start inline-flex relative">
            <div class="w-full flex-col justify-start items-center gap-3.5 flex lg:pb-12 pb-10">
                <h2 class="text-center text-white text-4xl font-bold font-manrope leading-normal">
                    {{ t('pages.faceSwapPhoto.templates.title') }}
                </h2>
                <p class="lg:max-w-4xl w-full text-center text-white/50 text-base font-normal leading-relaxed">
                    {{ t('pages.faceSwapPhoto.templates.description') }}
                </p>
            </div>
            <div class="w-full md:h-[600px] h-[400px] overflow-hidden relative flex flex-row gap-6">
                <div class="z-30 absolute inset-0 bg-gradient-to-b from-neutral-950 via-transparent to-transparent">
                </div>

                <div class="swiper-container w-fit" ref="swiperContainer1">
                    <div class="swiper-wrapper w-fit h-fit flex gap-8">
                        <div v-for="image in images1" :key="image" class="swiper-slide w-[200px] h-[250px]">
                            <img :src="image" alt="gallery-image" class="w-[200px] h-[250px] rounded-2xl" />
                        </div>
                    </div>
                </div>

                <div class="swiper-container w-[200px]" ref="swiperContainer2">
                    <div class="swiper-wrapper w-fit h-fit flex gap-8">
                        <div v-for="image in images2" :key="image" class="swiper-slide w-[200px] h-[250px]">
                            <img :src="image" alt="gallery-image" class="w-[200px] h-[250px] rounded-2xl" />
                        </div>
                    </div>
                </div>

                <div class="swiper-container w-fit" ref="swiperContainer3">
                    <div class="swiper-wrapper w-fit h-fit flex gap-8">
                        <div v-for="image in images3" :key="image" class="swiper-slide w-[200px] h-[250px]">
                            <img :src="image" alt="gallery-image" class="w-[200px] h-[250px] rounded-2xl" />
                        </div>
                    </div>
                </div>

                <div class="swiper-container w-fit" ref="swiperContainer4">
                    <div class="swiper-wrapper w-fit h-fit flex gap-8">
                        <div v-for="image in images4" :key="image" class="swiper-slide w-[200px] h-[250px]">
                            <img :src="image" alt="gallery-image" class="w-[200px] h-[250px] rounded-2xl" />
                        </div>
                    </div>
                </div>


                <div class="swiper-container w-fit" ref="swiperContainer5">
                    <div class="swiper-wrapper w-fit h-fit flex gap-8">
                        <div v-for="image in images5" :key="image" class="swiper-slide w-[200px] h-[250px]">
                            <img :src="image" alt="gallery-image" class="w-[200px] h-[250px] rounded-2xl" />
                        </div>
                    </div>
                </div>


                <div class="swiper-container w-fit" ref="swiperContainer6">
                    <div class="swiper-wrapper w-fit h-fit flex gap-8">
                        <div v-for="image in images6" :key="image" class="swiper-slide w-[200px] h-[250px]">
                            <img :src="image" alt="gallery-image" class="w-[200px] h-[250px] rounded-2xl" />
                        </div>
                    </div>
                </div>

                <div class="z-30 absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-transparent">
                </div>
            </div>
        </div>

        <div class="mt-12 w-full flex justify-center">
            <FaceSwapBtn></FaceSwapBtn>
        </div>
    </section>
</template>

<script setup lang="ts">
import FaceSwapBtn from './FaceSwapBtn.vue';

const { t } = useI18n();
const images1 = [
    '/idx/templates/png_templates_photo_01.webp',
    '/idx/templates/png_templates_photo_02.webp',
    '/idx/templates/png_templates_photo_03.webp',
    '/idx/templates/png_templates_photo_04.webp',
    '/idx/templates/png_templates_photo_05.webp',
    '/idx/templates/png_templates_photo_06.webp',
    '/idx/templates/png_templates_photo_07.webp',
    '/idx/templates/png_templates_photo_08.webp'
];

const images2 = [
    '/idx/templates/png_templates_photo_09.webp',
    '/idx/templates/png_templates_photo_10.webp',
    '/idx/templates/png_templates_photo_11.webp',
    '/idx/templates/png_templates_photo_12.webp',
    '/idx/templates/png_templates_photo_13.webp',
    '/idx/templates/png_templates_photo_14.webp',
    '/idx/templates/png_templates_photo_15.webp',
    '/idx/templates/png_templates_photo_16.webp'
];

const images3 = [
    '/idx/templates/png_templates_photo_17.webp',
    '/idx/templates/png_templates_photo_18.webp',
    '/idx/templates/png_templates_photo_19.webp',
    '/idx/templates/png_templates_photo_20.webp',
    '/idx/templates/png_templates_photo_21.webp',
    '/idx/templates/png_templates_photo_22.webp',
    '/idx/templates/png_templates_photo_23.webp',
    '/idx/templates/png_templates_photo_24.webp'
];

const images4 = [
    '/idx/templates/png_templates_photo_25.webp',
    '/idx/templates/png_templates_photo_26.webp',
    '/idx/templates/png_templates_photo_27.webp',
    '/idx/templates/png_templates_photo_28.webp',
    '/idx/templates/png_templates_photo_29.webp',
    '/idx/templates/png_templates_photo_30.webp',
    '/idx/templates/png_templates_photo_31.webp',
    '/idx/templates/png_templates_photo_32.webp'
];

const images5 = [
    '/idx/templates/png_templates_photo_33.webp',
    '/idx/templates/png_templates_photo_34.webp',
    '/idx/templates/png_templates_photo_35.webp',
    '/idx/templates/png_templates_photo_36.webp',
    '/idx/templates/png_templates_photo_37.webp',
    '/idx/templates/png_templates_photo_38.webp',
    '/idx/templates/png_templates_photo_39.webp',
    '/idx/templates/png_templates_photo_40.webp'
];

const images6 = [
    '/idx/templates/png_templates_photo_41.webp',
    '/idx/templates/png_templates_photo_42.webp',
    '/idx/templates/png_templates_photo_43.webp',
    '/idx/templates/png_templates_photo_44.webp',
    '/idx/templates/png_templates_photo_45.webp',
    '/idx/templates/png_templates_photo_46.webp',
    '/idx/templates/png_templates_photo_47.webp',
    '/idx/templates/png_templates_photo_48.webp'
];

const swiperContainer1 = ref(null);
const swiperContainer2 = ref(null);
const swiperContainer3 = ref(null);
const swiperContainer4 = ref(null);
const swiperContainer5 = ref(null);
const swiperContainer6 = ref(null);

const utils = useUtils()
onMounted(async () => {
    await utils.loadScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
    new Swiper(swiperContainer1.value, {
        direction: 'vertical',
        loop: true,
        centeredSlides: true,
        speed: 5000,
        autoplay: {
            delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper(swiperContainer2.value, {
        direction: 'vertical',
        loop: true,
        speed: 7000,
        autoplay: {
            delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper(swiperContainer3.value, {
        direction: 'vertical',
        loop: true,
        centeredSlides: true,
        speed: 5000,
        autoplay: {
            delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper(swiperContainer4.value, {
        direction: 'vertical',
        loop: true,
        centeredSlides: true,
        speed: 7000,
        autoplay: {
            delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper(swiperContainer5.value, {
        direction: 'vertical',
        loop: true,
        centeredSlides: true,
        speed: 5000,
        autoplay: {
            delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });

    new Swiper(swiperContainer6.value, {
        direction: 'vertical',
        loop: true,
        centeredSlides: true,
        speed: 7000,
        autoplay: {
            delay: 1,
        },
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
    });
});
</script>